import { useState } from 'react';
import { NeonBadge } from './UI';
import { colors, fonts } from '../lib/styles';

export default function ListingCard({ listing, onClick }) {
  const [hovered, setHovered] = useState(false);
  const bidCount = listing.bids?.length ?? 0;
  const lowestBid = bidCount > 0 ? Math.min(...listing.bids.map(b => b.amount)) : null;

  const timeAgo = (ts) => {
    const diff = Date.now() - new Date(ts).getTime();
    const m = Math.floor(diff / 60000);
    if (m < 60) return `${m}m ago`;
    const h = Math.floor(m / 60);
    if (h < 24) return `${h}h ago`;
    return `${Math.floor(h / 24)}d ago`;
  };

  return (
    <div
      onClick={() => onClick(listing)}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        background: hovered ? colors.bgCardHover : colors.bgCard,
        border: `1px solid ${hovered ? '#00ffc840' : colors.border}`,
        borderLeft: `3px solid ${listing.urgent ? colors.red : colors.cyan}`,
        borderRadius: '4px', padding: '20px 24px', cursor: 'pointer',
        transition: 'all 0.2s ease',
        boxShadow: hovered ? '0 0 20px rgba(0,255,200,0.06)' : 'none',
        position: 'relative', overflow: 'hidden',
        animation: 'fadeIn 0.3s ease',
      }}
    >
      {hovered && (
        <div style={{
          position: 'absolute', top: 0, left: 0, right: 0, height: '1px',
          background: 'linear-gradient(90deg,transparent,#00ffc8,transparent)',
          animation: 'scanH 1.5s linear infinite',
        }} />
      )}

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '10px' }}>
        <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
          <NeonBadge color={listing.urgent ? colors.red : colors.cyan}>{listing.category}</NeonBadge>
          {listing.urgent && <NeonBadge color={colors.red}>URGENT</NeonBadge>}
          {listing.pricing_type === 'bid' && <NeonBadge color={colors.purple}>OPEN BID</NeonBadge>}
        </div>
        <span style={{ fontFamily: fonts.mono, fontSize: '10px', color: colors.textFaint, whiteSpace: 'nowrap', marginLeft: '8px' }}>
          {timeAgo(listing.created_at)}
        </span>
      </div>

      <h3 style={{
        fontFamily: fonts.display, fontSize: '14px', fontWeight: 700,
        color: colors.text, margin: '0 0 8px', letterSpacing: '0.03em', lineHeight: 1.4,
      }}>{listing.title}</h3>

      <p style={{
        fontFamily: fonts.mono, fontSize: '12px', color: colors.textDim,
        margin: '0 0 14px', lineHeight: 1.6,
        display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden',
      }}>{listing.description}</p>

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
          <span style={{ fontFamily: fonts.mono, fontSize: '11px', color: colors.textFaint }}>📍 {listing.location}</span>
          <span style={{ fontFamily: fonts.mono, fontSize: '11px', color: '#00ffc840' }}>by {listing.profiles?.handle || 'anonymous'}</span>
        </div>
        <div style={{ textAlign: 'right' }}>
          {listing.pricing_type === 'fixed' ? (
            <span style={{ fontFamily: fonts.display, fontSize: '18px', fontWeight: 800, color: colors.cyan }}>
              ${listing.price}
            </span>
          ) : lowestBid ? (
            <div>
              <span style={{ fontFamily: fonts.mono, fontSize: '9px', color: colors.purple, display: 'block', letterSpacing: '0.1em' }}>LOW BID</span>
              <span style={{ fontFamily: fonts.display, fontSize: '18px', fontWeight: 800, color: colors.purple }}>${lowestBid}</span>
            </div>
          ) : (
            <span style={{ fontFamily: fonts.mono, fontSize: '11px', color: colors.textFaint }}>No bids yet</span>
          )}
          {bidCount > 0 && (
            <div style={{ fontFamily: fonts.mono, fontSize: '10px', color: colors.textFaint, marginTop: '2px' }}>
              {bidCount} bid{bidCount !== 1 ? 's' : ''}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
